/* Free resources nudge (sections/hc-free-resources.liquid): when to show, collapse, dismiss, and how to sit above sticky bars. */
(function () {
  var root = document.querySelector('[data-hcr]');
  if (!root) return;

  var panel = root.querySelector('[data-hcr-panel]');
  var pill = root.querySelector('[data-hcr-pill]');
  var editor = root.hasAttribute('data-hcr-editor');
  var version = root.dataset.version || '1';
  var delay = Math.max(3, +root.dataset.delay || 5) * 1000;
  var DAY = 864e5;
  var KEY = 'hc-free-resources', SKEY = 'hc-free-resources-session';
  // Fixed bottom bars the nudge sits above. While the cookie banner is up the nudge waits off screen instead of stacking on it.
  var BARS = ['.hsb-bar.is-on', '.hvp-sticky.is-on', '.hcl-stickybar', '.hc-cart-sticky'];
  var COOKIE = '#shopify-pc__banner';
  var desktop = window.matchMedia('(min-width: 750px)');
  var collapseTimer, started = Date.now();

  function read(store, key) { try { return JSON.parse(store.getItem(key) || 'null'); } catch (e) { return null; } }
  function write(store, key, val) { try { store.setItem(key, JSON.stringify(val)); } catch (e) {} }
  function track(action, item) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('hc_free_resources', { action: action, item: item || '' }); } catch (e) {}
  }
  function visible(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) return false;
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.top < window.innerHeight - 4;
  }

  var saved = read(localStorage, KEY);
  if (!editor && saved && saved.v === version && saved.until > Date.now()) return;

  function snooze(days) {
    write(localStorage, KEY, { v: version, until: Date.now() + days * DAY });
  }

  /* Lift above whichever sticky bar is showing; step aside while a drawer or menu is open. */
  function place() {
    var lift = 0;
    BARS.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (visible(el)) lift = Math.max(lift, window.innerHeight - el.getBoundingClientRect().top);
    });
    root.style.setProperty('--hcr-bottom', Math.round(lift) + 'px');
    root.classList.toggle('is-away', document.body.classList.contains('overflow-hidden') || document.documentElement.classList.contains('hc-menu-open') || visible(document.querySelector(COOKIE)));
  }
  var queued = false;
  function queuePlace() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; place(); });
  }

  function open(auto) {
    clearTimeout(collapseTimer);
    root.classList.add('is-open');
    pill.setAttribute('aria-expanded', 'true');
    write(sessionStorage, SKEY, 'seen');
    // A card that opened by itself folds back into the pill if it is ignored.
    if (auto) collapseTimer = setTimeout(function () { if (!root.matches(':hover') && !root.contains(document.activeElement)) collapse(); }, 12000);
  }
  function collapse() {
    clearTimeout(collapseTimer);
    root.classList.remove('is-open');
    pill.setAttribute('aria-expanded', 'false');
  }
  function close() {
    snooze(7);
    track('close');
    root.classList.add('is-away');
    setTimeout(function () { root.hidden = true; }, 350);
  }

  function show(seenBefore) {
    root.hidden = false;
    place();
    window.addEventListener('scroll', queuePlace, { passive: true });
    window.addEventListener('resize', queuePlace);
    setInterval(place, 1000);
    track('show');
    // Desktop gets the card once per session; phones (and later pages) just get the pill.
    if (editor || (!seenBefore && desktop.matches)) open(!editor);
    write(sessionStorage, SKEY, 'seen');
  }

  root.addEventListener('click', function (e) {
    var item = e.target.closest('[data-hcr-item]');
    if (item) { snooze(30); track('click', item.dataset.hcrItem); return; }
    if (e.target.closest('[data-hcr-close]')) { close(); return; }
    if (e.target.closest('[data-hcr-min]')) { collapse(); pill.focus(); return; }
    if (e.target.closest('[data-hcr-pill]')) { open(false); track('open'); }
  });
  root.addEventListener('mouseenter', function () { clearTimeout(collapseTimer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) { collapse(); pill.focus(); } });
  // On phones the open sheet closes when tapping elsewhere.
  document.addEventListener('click', function (e) { if (!desktop.matches && root.classList.contains('is-open') && !root.contains(e.target)) collapse(); });

  if (editor) { show(false); return; }
  var seenBefore = read(sessionStorage, SKEY) === 'seen';
  if (seenBefore) { setTimeout(function () { show(true); }, 1500); return; }

  /* First time this session: show on the first real scroll (half a screen) or after the delay, whichever comes first.
     Never in the first 2s; if the cookie banner is still up, place() keeps it off screen until the visitor answers it. */
  var shown = false;
  function trigger() {
    if (shown) return;
    shown = true;
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    show(false);
  }
  function onScroll() {
    if (Date.now() - started >= 2000 && window.scrollY > window.innerHeight * .5) trigger();
  }
  var timer = setTimeout(trigger, delay);
  window.addEventListener('scroll', onScroll, { passive: true });
  setTimeout(onScroll, 2000); // already scrolled down (e.g. returning to the page) before the 2s guard ended
})();
